import React from "react";
import { Modal } from "antd";
import KeyRoomTrends from "../../CustomerKeyDetail/KeyRoomTrends/KeyRoomTrends";

interface KeyListRoomTrendsModalProps {
  isOpen: boolean;
  onClose: () => void;
  selectedKey: any;
  locationId: string;
  locationName: string;
}

const KeyListRoomTrendsModal: React.FC<KeyListRoomTrendsModalProps> = ({
  isOpen,
  onClose,
  selectedKey,
  locationId,
  locationName,
}) => {
  return (
    <Modal
      title={`Room Trends for ${selectedKey?.positionName}`}
      open={isOpen}
      onCancel={onClose}
      footer={null}
      width={1200}
    >
      <KeyRoomTrends
        locationId={locationId}
        locationName={locationName || ""}
        roomName={selectedKey?.rooms?.[0]?.positionName ?? ""}
        keyName={selectedKey?.positionName}
      />
    </Modal>
  );
};

export default KeyListRoomTrendsModal;
